export default {
  switchGrid: true,
  gridSize: 20
}
